import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  email: string
  name: string
  is_active: boolean
  created_at: string
}

interface AuthState {
  token: string | null
  refreshToken: string | null
  sessionId: string | null
  user: User | null
  isLoading: boolean
  setAuth: (token: string, user: User) => void
  login: (authData: any) => void
  logout: () => void
  setLoading: (loading: boolean) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      sessionId: null,
      user: null,
      isLoading: false,
      setAuth: (token: string, user: User) =>
        set({ token, user, isLoading: false }),
      login: (authData: any) =>
        set({
          token: authData.access_token,
          refreshToken: authData.refresh_token,
          sessionId: authData.session_id,
          user: authData.user,
          isLoading: false
        }),
      logout: () =>
        set({ token: null, refreshToken: null, sessionId: null, user: null, isLoading: false }),
      setLoading: (isLoading: boolean) =>
        set({ isLoading }),
    }),
    {
      name: 'finpro-auth',
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        sessionId: state.sessionId,
        user: state.user
      }),
    }
  )
)